import React, { useEffect, useRef } from "react";
import "./styles.scss";
import { GetSLACSVReportData, GetSLAReportData } from "./tenantApiCalls";
import { slaReport, summaryReport } from "./interfaces";
import { FormatDate, FormatFullDate, FormatTime } from "../../Logic/DateTimeFormatters";
import Processing from "../Generic/Processing";
import * as XLSX from "xlsx";
import saveAs from "file-saver";
import { RootState } from "../../state/store";
import { useSelector } from "react-redux";

function ResponseCycleSLA(props: summaryReport) {
    const permissions = useSelector((state: RootState) => state.permissions);
    const [data, setData] = React.useState<Array<slaReport> | undefined>(undefined);
    const reportTable = useRef<HTMLTableElement>(null);
    const [reportData, setReportData] = React.useState<{
        dateFrom: string;
        dateTo: string;
    }>({
        dateFrom: "",
        dateTo: "",
    });

    useEffect(() => {
        (async () => {
            if (props.generateReport) {
                const result = await GetSLAReportData(props);
                if (result.isOk && result.data) {
                    let data = result.data.responseCycleSLAReportData;
                    setData(data);
                }
                const diffInMs =
                    new Date(new Date(props.dateTo.toString()).toDateString()).valueOf() -
                    new Date(new Date(props.dateFrom.toString()).toDateString()).valueOf();
                const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

                setReportData({
                    dateFrom: props.dateFrom.toString(),
                    dateTo: props.dateTo.toString(),
                });
            }
        })();
    }, [props.generateReport]);
    const exportData = async () => {
        const result = await GetSLACSVReportData(props);
        if (result.isOk && result.data) {
            let data = result.data.responseCycleSLADetailedReportData;
            const ws = XLSX.utils.json_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            const fileName = "SLA_Data_" + Date.now();

            XLSX.writeFile(wb, `${fileName}.xlsx`);
        }
    };
    const downloadReport = () => {
        if (reportTable.current) {
            // Create a workbook from the HTML table
            const workbook = XLSX.utils.table_to_book(reportTable.current);

            // Write the workbook to a binary string
            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            // Create a Blob and save the file
            const data = new Blob([excelBuffer], { type: "application/octet-stream" });
            const fileName = "SLA_Report_" + Date.now();
            saveAs(data, `${fileName}.xlsx`);
        }
    };
    return (
        <>
            {data == undefined && (
                <Processing>
                    {" "}
                    <p>
                        Getting Report Data
                        <br />
                        Please wait...
                    </p>
                </Processing>
            )}
            {data != undefined && (
                <div className="reportPadding">
                    <div>
                        <div style={{ textAlign: "right", paddingBottom: "7px" }}>
                            <button
                                className="g-btn g-btn-action"
                                onClick={downloadReport}
                            >
                                {" "}
                                Download Report
                            </button>{" "}
                            {permissions.Tenant.ElevatedReports && (
                                <button
                                    className="g-btn g-btn-action"
                                    onClick={exportData}
                                >
                                    {" "}
                                    Export Raw Data
                                </button>
                            )}
                        </div>
                        <table
                            className="reportTable"
                            ref={reportTable}
                        >
                            <thead>
                                <tr>
                                    <th
                                        style={{ width: "50%", fontSize: "14px", border: "0px" }}
                                        colSpan={8}
                                    >
                                        Response Cycle SLA Analysis
                                    </th>
                                    <th
                                        colSpan={7}
                                        rowSpan={2}
                                        className="right"
                                    >
                                        From: {FormatFullDate(reportData.dateFrom)}
                                        <br />
                                        To: {FormatFullDate(reportData.dateTo)}
                                    </th>
                                </tr>
                                <tr>
                                    <th
                                        style={{ border: "0px" }}
                                        colSpan={8}
                                    >
                                        Status of Mailboxes
                                    </th>
                                </tr>
                                <tr className="greyRow">
                                    <td
                                        rowSpan={2}
                                        className="center"
                                        style={{ borderLeft: "solid 1px #aaa" }}
                                    >
                                        Department
                                    </td>
                                    <td
                                        rowSpan={2}
                                        className="center"
                                    >
                                        Mailbox
                                    </td>
                                    <td
                                        rowSpan={2}
                                        className="center"
                                    >
                                        SLA Time
                                        <br />
                                        (min)
                                    </td>
                                    <td
                                        colSpan={5}
                                        className="center"
                                    >
                                        Actioned Responses
                                    </td>
                                    <td
                                        colSpan={4}
                                        className="center"
                                    >
                                        Unactioned Responses
                                    </td>
                                    <td
                                        colSpan={2}
                                        className="center"
                                    >
                                        Emails
                                    </td>
                                    <td
                                        rowSpan={2}
                                        className="center"
                                    >
                                        Oldest Unactioned Response
                                    </td>
                                </tr>
                                <tr className="greyRow">
                                    <td className="center">In SLA</td>
                                    <td className="center">%</td>
                                    <td className="center">Out SLA</td>
                                    <td className="center">%</td>
                                    <td className="center">Total</td>
                                    <td className="center">
                                        Expire before
                                        <br />
                                        {FormatDate(new Date(reportData.dateTo.toString()).toDateString())}
                                    </td>
                                    <td className="center">
                                        Expires
                                        <br />
                                        {FormatDate(new Date(reportData.dateTo.toString()).toDateString())}
                                    </td>
                                    <td className="center">
                                        Expires after
                                        <br />
                                        {FormatDate(new Date(reportData.dateTo.toString()).toDateString())}
                                    </td>
                                    <td className="center">
                                        Total responses
                                        <br />
                                        untouched
                                        <br />
                                    </td>
                                    <td className="center">In</td>
                                    <td className="center">Out</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    //user start
                                }
                                {data.map((x, index) => {
                                    return (
                                        <>
                                            <tr
                                                style={{
                                                    background: index % 2 === 0 ? "#fff" : "#f3f3f3",
                                                }}
                                            >
                                                <td style={{ borderLeft: "solid 1px #aaa" }}>{x.serviceCentreName}</td>
                                                <td>{x.mailboxName}</td>
                                                <td>{x.responseSlaMinutes}</td>
                                                <td className="right">{x.completedInSla}</td>
                                                <td className="right">{x.completedInSlaPercentage.toFixed(2)}</td>
                                                <td className="right">{x.completedOutSla}</td>
                                                <td className="right">{x.completedOutSlaPercentage.toFixed(2)}</td>
                                                <td className="right">{x.totalActioned}</td>
                                                <td className="right">{x.expireAlready}</td>
                                                <td className="right">{x.expireNext}</td>
                                                <td className="right">{x.expireFuture}</td>
                                                <td className="right">{x.responsesUntouched}</td>
                                                <td className="right">{x.emailsInbound}</td>
                                                <td className="right">{x.emailsOutbound}</td>
                                                <td className="right">{FormatFullDate(x.oldestResponse.toString())}</td>
                                            </tr>
                                        </>
                                    );
                                })}
                                {
                                    //user end
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
    );
}
export default ResponseCycleSLA;
